module.exports = __webpack_public_path__ + "static/media/113.4bdf7b90.svg";